import * as THREE from 'three';
import { useEffect, useRef } from "react";
import { AudioSystemUtil, audioTracks } from "../particles/AudioSystemUtil";
import { useLocation } from "react-router-dom";
import { useDayNightCycle } from "../hooks/useDayNightCycle";

const skyColorDay = new THREE.Color(0xfff8f2);
const skyColorNight = new THREE.Color(0x3333ff);
const groundColorDay = new THREE.Color(0xffe2d2);
const groundColorNight = new THREE.Color(0xffffff);

export const Environment = ({
  sceneView
}: {
  sceneView: string
}) => {
  const hemisphereLightRef = useRef<THREE.HemisphereLight>(null!);
  const directionalLightRef = useRef<THREE.DirectionalLight>(null!);
  const route = useLocation();

  useEffect(() => {
    (async () => {
      const environmentTracks: Array<keyof typeof audioTracks> = [];

      if (sceneView === 'TreeView') {
        environmentTracks.push('ambient-theme');

        if (route.pathname === '/') {
          environmentTracks.push('ambient-birds-chirp');
        }
      } else if (sceneView === 'TempleView') {
        environmentTracks.push('ambient-battle');
      }

      await AudioSystemUtil.stopSome({
        exclude: environmentTracks
      });

      for (let trackName of environmentTracks) {
        AudioSystemUtil.play(trackName as keyof typeof audioTracks, true);
      }
    })();
  }, [sceneView, route.pathname]);

  useEffect(() => {
    if (!hemisphereLightRef.current || !directionalLightRef.current) {
      return;
    }

    if (sceneView !== 'TreeView') {
      hemisphereLightRef.current.color.lerpColors(skyColorDay, skyColorNight, 0.0);
      hemisphereLightRef.current.groundColor.lerpColors(groundColorDay, groundColorNight, 0.0);
  
      directionalLightRef.current.intensity = 2.0;
    }
  }, [sceneView])

  useDayNightCycle(({ daynightCycle }) => {
    if (!hemisphereLightRef.current || !directionalLightRef.current) {
      return;
    }

    if (sceneView !== 'TreeView') {
      hemisphereLightRef.current.color.lerpColors(skyColorDay, skyColorNight, 0.0);
      hemisphereLightRef.current.groundColor.lerpColors(groundColorDay, groundColorNight, 0.0);
  
      directionalLightRef.current.intensity = 2.0;
    } else {
      hemisphereLightRef.current.color.lerpColors(skyColorDay, skyColorNight, (daynightCycle + 1.0) / 2.0);
      hemisphereLightRef.current.groundColor.lerpColors(groundColorDay, groundColorNight, (daynightCycle + 1.0) / 2.0);
  
      directionalLightRef.current.intensity = THREE.MathUtils.lerp(2.0, 1.0, daynightCycle);
    }
  });

  return (
    <>
      <hemisphereLight ref={hemisphereLightRef} />
      <directionalLight
        ref={directionalLightRef}
        castShadow={false}
        color="#ffe2d2"
        position={[10, 20, 10]}
        intensity={2.0}
      />
    </>
  )
};
